<template>
  <div class="job container">
        <div v-if="job">
            <h1>{{this.job.title}}</h1>
            <h2>Location: {{this.job.offices[0].name}}</h2>
            <h2>Department: {{this.job.departments[0].name}}</h2>
        </div>
        <div id="grnhse_app"></div>
  </div>
</template>

<script>
import axios from "axios";

export default {
    name: 'Job',
    components: {
    },
    data() {
        return {
            job: null,
        }
    },
    mounted() {
        this.getData();
        //this.scrollToTop();
        document.getElementById('section-3-7').style.display = 'none';
    },
    methods: {
        scrollToTop() {
            const yOffset = -180; 
            const element = document.getElementById('app');
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: "smooth"});
        },
        getData() {
            let url = "https://boards-api.greenhouse.io/v1/boards/" + process.env.VUE_APP_GH_BOARD + "/jobs";
            let requestUrl = url + '/' + this.$route.params.id;
            axios
                .get(requestUrl)
                .then(response => {
                this.job = response.data;
                // eslint-disable-next-line no-undef
                Grnhse.Iframe.load(this.job.id);
                });
        },
        htmlDecode(input) {
            var doc = new DOMParser().parseFromString(input, "text/html");
            return doc.documentElement.textContent;
        }
    },
    computed: {
        decodedContent: function () {
            return this.htmlDecode(this.job.content);
        }
    }  
}

</script>